import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import style from './index.module.scss'
import Half from './half'

const HalfHalf = ({ children, isEvolved = false }) => (
  <div className={classNames(style.HalfHalf, { [style.evolved]: isEvolved })}>
    {children}
  </div>
)

HalfHalf.propTypes = {
  children: PropTypes.node,
  isEvolved: PropTypes.bool,
}

export { Half, HalfHalf }
